import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {notificationController} from '../../../../../shared/scripts/EntryShared'
import {ProfileEditAjaxEndPoints} from '../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {UIProfileUsernameController} from '../../../../../shared/scripts/ui_html/header/UIProfileUsernameController'

export class UIMProfileUsernameController extends UIProfileUsernameController {
    // eslint-disable-next-line class-methods-use-this
    async updateUsername(newUsername: string, shouldPurchaseIfNoAttemptsLeft: boolean = false) {
        const success = await ProfileEditAjaxEndPoints.updateUsername(newUsername, shouldPurchaseIfNoAttemptsLeft)
        if(!success) return
        const successMessage: TranslationObject = {key: 'strings:homePage.header.changeUsername.confirm.notification'}
        notificationController.showNotification(LobbyImage.InfoIcon, successMessage, 5000)
    }
}
